import {
  getStatus,
  getIconType,
  getImportance,
  getSolvability,
} from '../../constants/seoMappings';

const clamp = (n, min, max) => Math.min(max, Math.max(min, n));

const getLabelForScore = (score) => {
  // Keep simple, user-friendly labels; legacy shows "Very Good" at 4/5.
  if (score >= 5) return 'Excellent';
  if (score >= 4) return 'Very Good';
  if (score >= 3) return 'Good';
  if (score >= 2) return 'Fair';
  return 'Poor';
};

/**
 * Transforms the backlinks_score criteria from WooRank API response.
 * Legacy view expects a 0-5 score and a progress bar width of score*20.
 *
 * @param {Object} backlinksScoreCriteria - criteria.backlinks_score
 * @returns {Object} transformed criteria
 */
export const transformBacklinksScore = (backlinksScoreCriteria) => {
  if (!backlinksScoreCriteria) {
    return {
      status: 'error',
      iconType: 'error',
      importance: { level: 0, text: '' },
      solvability: { level: 0, text: '' },
      isEmpty: true,
      message: 'The backlinks score was not able to be calculated.',
      data: null,
    };
  }

  const wooRankStatus = backlinksScoreCriteria?.status || 'neutral';
  const importance = backlinksScoreCriteria?.importance || 0;
  const solvability = backlinksScoreCriteria?.solvability || 0;

  const rawScore = Number(backlinksScoreCriteria?.data?.score);
  const hasScore = Number.isFinite(rawScore);

  if (!hasScore) {
    return {
      status: 'error',
      iconType: 'error',
      importance: getImportance(importance),
      solvability: getSolvability(solvability),
      isEmpty: true,
      message: 'The backlinks score was not able to be calculated.',
      data: null,
    };
  }

  const score = clamp(rawScore, 0, 5);
  const percent = score * 20;

  return {
    status: getStatus(wooRankStatus),
    iconType: getIconType(wooRankStatus),
    importance: getImportance(importance),
    solvability: getSolvability(solvability),
    isEmpty: false,
    message: null,
    data: {
      score,
      percent,
      label: getLabelForScore(score),
      scoreText: `${Math.round(percent)}/100`,
    },
  };
};

export default transformBacklinksScore;


